module.exports = __webpack_public_path__ + "static/media/clock-fill.586887a3.svg";